import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

const METHODS = [
  ["hourly", "Hours on site × hourly rate", "Lines fill in from the crew's clocked time on the job."],
  ["job_type", "Set price per job type", "Each job type has its own price."],
  ["manual", "Type the lines yourself", "Starts with the job name and $0."],
];

const ItemsEditor = ({ items, setItems }) => {
  const set = (i, k, v) => setItems(items.map((it, j) => (j === i ? { ...it, [k]: v } : it)));
  return (
    <div className="space-y-2" data-testid="settings-items">
      {items.map((it, i) => (
        <div key={i} className="grid grid-cols-[1fr_110px_32px] gap-2">
          <Input value={it.description} placeholder="e.g. Call-out fee" onChange={(e) => set(i, "description", e.target.value)} data-testid={`settings-item-desc-${i}`} />
          <Input value={it.price} inputMode="decimal" placeholder="0.00" onChange={(e) => set(i, "price", e.target.value)} className="text-right" data-testid={`settings-item-price-${i}`} />
          <Button type="button" variant="ghost" size="icon" onClick={() => setItems(items.filter((_, j) => j !== i))} className="h-9 w-9 rounded-full text-muted-foreground hover:text-destructive" data-testid={`settings-item-remove-${i}`}><Trash2 className="w-4 h-4" /></Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={() => setItems([...items, { description: "", price: "" }])} className="rounded-full" data-testid="settings-add-item"><Plus className="w-3.5 h-3.5 mr-1" /> Add saved item</Button>
    </div>
  );
};

export const PricingFields = ({ f, set, jobTypes }) => (
  <section className="space-y-4" data-testid="settings-pricing">
    <h3 className="font-semibold">How invoices are priced</h3>
    <RadioGroup value={f.pricing} onValueChange={(v) => set("pricing", v)} className="grid gap-2">
      {METHODS.map(([v, label, hint]) => (
        <label key={v} className={`flex items-start gap-3 rounded-xl border p-3 cursor-pointer transition-colors ${f.pricing === v ? "border-primary bg-primary/5" : "border-border"}`}>
          <RadioGroupItem value={v} className="mt-0.5" data-testid={`settings-pricing-${v}`} />
          <span><span className="block text-sm font-medium">{label}</span><span className="block text-xs text-muted-foreground">{hint}</span></span>
        </label>
      ))}
    </RadioGroup>
    {f.pricing === "hourly" && (
      <div className="space-y-1.5 max-w-xs"><Label className="text-xs">Hourly rate (ex GST)</Label>
        <Input value={f.hourly_rate} inputMode="decimal" onChange={(e) => set("hourly_rate", e.target.value)} placeholder="e.g. 85.00" data-testid="settings-hourly-rate" /></div>
    )}
    {f.pricing === "job_type" && (
      <div className="grid sm:grid-cols-2 gap-2" data-testid="settings-type-prices">
        {jobTypes.map((t) => (
          <div key={t.id} className="flex items-center gap-2"><span className="flex-1 text-sm truncate">{t.label}</span>
            <Input value={f.type_prices[t.id] ?? ""} inputMode="decimal" placeholder="0.00" className="w-28 text-right"
              onChange={(e) => set("type_prices", { ...f.type_prices, [t.id]: e.target.value })} data-testid={`settings-type-price-${t.id}`} /></div>
        ))}
      </div>
    )}
    <div className="space-y-1.5"><Label className="text-xs">Saved items (one tap to add them to any invoice, prices ex GST)</Label>
      <ItemsEditor items={f.items} setItems={(v) => set("items", v)} /></div>
  </section>
);
